<template>
  <b-row>
    <b-col cols="12">
      <support-category-edit-form />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import SupportCategoryEditForm from './SupportCategoryEditForm.vue'

export default {
  components: {
    BRow,
    BCol,
    SupportCategoryEditForm,
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-wizard.scss';
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
